import { render, staticRenderFns } from "./MultiScreenButtons.vue?vue&type=template&id=d298f458&scoped=true&lang=pug&"
import script from "./MultiScreenButtons.vue?vue&type=script&lang=js&"
export * from "./MultiScreenButtons.vue?vue&type=script&lang=js&"
import style0 from "./MultiScreenButtons.vue?vue&type=style&index=0&id=d298f458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d298f458",
  null
  
)

export default component.exports